interface DownloadFileOptions {
  data: BlobPart;
  filename: string;
  format: keyof typeof CONTENT_TYPE_MAP;
}

export const CONTENT_TYPE_MAP = {
  csv: "text/csv",
  pdf: "application/pdf",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
} as const;

export function downloadFile({ data, filename, format }: DownloadFileOptions) {
  const type = CONTENT_TYPE_MAP[format];
  const blob = new Blob([data], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.${format}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
